import { fetcher } from '@commenda/utils';
import { readServingRuleError } from './readServingRuleError';
import { LocationServingRuleResponse } from './types';

export async function updateLocationServingRule(
  locationId: string,
  servingRuleId: string,
  body: {
    effective_start_date?: string;
    effective_end_date?: string;
  }
): Promise<{
  success: boolean;
  data?: LocationServingRuleResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/locations/${locationId}/serving-rules/${servingRuleId}`,
      { method: 'POST', body }
    );

    if (!response.ok) {
      return {
        success: false,
        error: await readServingRuleError(
          response,
          'Failed to update serving rule'
        ),
      };
    }

    return { success: true, data: await response.json() };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to update serving rule',
    };
  }
}
